module.exports = __webpack_public_path__ + "img/PM_A02_front_en.9f3b00cc.png";